var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10C24 11.1046 23.0863 12 21.9592 12L2.04081 12C0.913703 12 -4.85396e-07 11.1046 -4.37114e-07 10L-8.74228e-08 2C-3.91405e-08 0.895429 0.913704 -1.00913e-06 2.04082 -9.59866e-07L21.9592 -8.92069e-08C23.0863 -3.99393e-08 24 0.895431 24 2L24 10ZM22.7754 3.20928L22.7754 2.40012C22.7754 1.77636 22.2898 1.26376 21.6688 1.20561L21.5509 1.20012L2.44886 1.20012C1.81237 1.20012 1.28931 1.67603 1.22998 2.28455L1.22437 2.40012L1.22437 9.60012C1.22437 10.2239 1.70999 10.7365 2.33093 10.7946L2.44886 10.8001L21.5509 10.8001C22.1874 10.8001 22.7105 10.3242 22.7698 9.71569L22.7754 9.60012L22.7754 8.844C22.5439 8.85703 22.3795 8.68435 22.2824 8.32595C22.1367 7.78836 22.1899 7.19914 22.1899 6.00012L22.1876 4.89394C22.191 4.46324 22.2099 4.14636 22.2824 3.62939C22.3537 3.46851 22.4846 3.34264 22.6751 3.25179L22.7754 3.20928Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7754 1.2002C22.3277 1.2002 22.7754 1.64791 22.7754 2.2002L22.7754 3.20936C22.7754 3.20936 22.4071 3.34792 22.2824 3.62947C22.1615 4.49108 22.1899 4.79689 22.1899 6.0002C22.1899 7.19921 22.1367 7.78844 22.2824 8.32603C22.4281 8.86363 22.7754 8.84408 22.7754 8.84408L22.7754 9.8002C22.7754 10.3525 22.3277 10.8002 21.7754 10.8002L2.72437 10.8002C1.89594 10.8002 1.22437 10.1286 1.22437 9.3002L1.22437 2.70019C1.22437 1.87177 1.89594 1.20019 2.72437 1.20019L21.7754 1.2002Z",
    fill: "#FCFCFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-phone.041b230d783bb2f0703db32a58b50b84.svg";